Monitoring.Views ||= {}

class Monitoring.Views.MovistarOwnershipConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_ownership_condition_edit"]

  initialize: (@options = {}) ->
    @initiallySelectedOwnership = @options.selectedOwnership

  render : ->
    @$el.html(@template(@))
    @initializeToggle()
    @

  initializeToggle: ->
    @$el.find('#condition-ownership').bootstrapToggle({
      onstyle: 'success'
      offstyle: 'warning'
    })

  getSelectedOwnership: ->
    if @$el.find('#condition-ownership').prop('checked') then 'not-own-content' else 'all-content'
